












































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import NoticePO from "@/store/entities/messageinfo/noticepo";
import TreeSelect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Moment from "moment";
import Util from "@/lib/util";

@Component({
  components: { TreeSelect },
})
export default class EditNotice extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  noticepo: NoticePO = new NoticePO();
  loading: boolean = false;
  async created() {
    await this.getOrganizations();
    await this.areaTree();
  }
  //获取组织
  async getOrganizations() {
    await this.$store
      .dispatch("organization/getselectTree")
      .then((val) => {
        this.$data.organizations = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  //改变时间
  changeDate(val) {
    this.noticepo.effectiveTime = val;
  }
  //保存
  save() {
    (this.$refs.itemForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        await this.$store
          .dispatch({
            type: "notice/update",
            data: this.noticepo,
          })
          .catch((err) => {
            this.loading = false;
          });
        this.loading = false;
        (this.$refs.itemForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  async areaTree() {
    await this.$store
      .dispatch("area/getAreaSelectTree")
      .then((val) => {
        this.$data.arealist = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  cancel() {
    (this.$refs.itemForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }else{
        this.noticepo = Util.extend(true, {}, this.$store.state.notice.noticeItems);
    }
  }
  itemRule = {
    areaId: [
      {
        required: true,
        type: "number",
        message: this.L("FieldIsRequired"),
        trigger: "blur",
      },
    ],
    organizationId: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    level: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    title: [
      {
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    content: [
      {
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    effectiveTime: [
      {
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
  };

  data() {
    return {
      arealist: [],
      organizations: [], //组织
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
          isDisabled: node.type == 1 ? true : false,
        };
      },
    };
  }
}
